import { branch, compose, lifecycle, renderComponent } from 'recompose';
import { connect } from 'react-redux';
import { get, partial } from 'lodash';
import { bindActionCreators } from 'redux';

import { isEditMode } from '../helpers/isEditMode';
import { getBarber, resetBarber } from '../../../actions/brand';
import Loading from '../../../../customers/customersList/loading';
import {
  getBrandBarberId,
  getBrandBarberShopIdList,
  isLoadingBrandBarber,
} from '../../../selector';

export default compose(
  connect(state => ({
    isLoadingBrandBarber: isLoadingBrandBarber(state),
    brandBarberId: getBrandBarberId(state),
    brandBarberShopIds: getBrandBarberShopIdList(state),
  }),
    (dispatch, ownProps) => bindActionCreators({
      fetchBarber: partial(getBarber, ownProps.brandId),
      resetBarber,
    }, dispatch),
  ),
  lifecycle({
    componentDidMount() {
      if (isEditMode(this.props)) {
        const barberId = get(this.props, 'params.barberId');
        this.props.fetchBarber(barberId);
      }
    },
    componentWillUnmount() {
      this.props.resetBarber();
    },
  }),
  branch(
    props => (
      isEditMode(props) && (
        !props.brandBarberShopIds.length
        || props.brandBarberId !== props.params.barberId
        || props.isLoadingBrandBarber
      )
    ),
    renderComponent(Loading)
  ),
);
